import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import OrganizationSection from "./components/OrganizationSection";
import BusinessSection from "./components/BusinessSection";
import CompetitiveSection from "./components/CompetitiveSection";
import VietnamSection from "./components/VietnamSection";
import VisionSection from "./components/VisionSection";
import InquirySection from "./components/InquirySection";
import GallerySection from "./components/GallerySection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  useScrollAnimation();

  return (
    <div className="flex flex-col">
      <HeroSection />
      <AboutSection />
      <OrganizationSection />
      <BusinessSection />
      <CompetitiveSection />
      <VietnamSection />
      <VisionSection />
      <InquirySection />
      <GallerySection />
      <ContactSection />
    </div>
  );
}
